import React from "react";
import moment from "moment";
import { useStreamTime } from "../../../hooks/useStreamTime";
import { useConfig } from "../../../hooks/useConfig";
import { useTV } from "../../../hooks/useTV";
// import OffStreamBottomBar from "./OffStreamBottomBar";
// import { useRemote } from "../../../hooks/useRemote";
// import useGlobalStore from "../../../store/global.store";

const OffStreamView = () => {
  const { config } = useConfig();
  const { isTv } = useTV();
  // const { updateView } = useRemote();
  const {
    showStream,
    offStreamVideo,
    getEpcotShowTimeText,
    getMagicKingdomShowTimeText,
  } = useStreamTime();
  // const setSelectedVipDoor = useGlobalStore(
  //   (state) => state.setSelectedVipDoor
  // );
  // const setShowVipSelector = useGlobalStore(
  //   (state) => state.setShowVipSelector
  // );

  // const handleBackClick = () => {
  //   setSelectedVipDoor("door2");
  //   updateView("VIP", () => {
  //     setShowVipSelector(true);
  //     setSelectedVipDoor("door2");
  //   });
  // };

  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        zIndex: 10,
      }}
    >
      <video
        src={`https://cdn.mywaitserver.live/${offStreamVideo}`}
        autoPlay={true}
        muted={true}
        loop={true}
        style={
          isTv
            ? {
                width: "100vw",
                height: "100vh",
                objectFit: "cover",
              }
            : {}
        }
      />
      {offStreamVideo === "stream-off-vid.mp4" && (
        <>
          <span
            style={
              isTv
                ? {
                    zIndex: 40,
                    position: "absolute",
                    top: "35.5%",
                    left: "55%",
                    fontSize: 73,
                    fontFamily: "IMPACT",
                    fontStyle: "normal",
                    opacity: showStream === false ? 1 : 0,
                    transition: "all 2s",
                  }
                : {
                    zIndex: 40,
                    position: "absolute",
                    top: "37%",
                    left: "55%",
                    fontSize: 50,
                    fontFamily: "IMPACT",
                    fontStyle: "normal",
                    opacity: showStream === false ? 1 : 0,
                    transition: "all 2s",
                  }
            }
          >
            {getMagicKingdomShowTimeText()}
          </span>

          <span
            style={
              isTv
                ? {
                    zIndex: 40,
                    position: "absolute",
                    top: "44.5%",
                    left: "48%",
                    fontSize: 73,
                    fontFamily: "IMPACT",
                    fontStyle: "normal",
                    opacity: showStream === false ? 1 : 0,
                    transition: "all 2s",
                  }
                : {
                    zIndex: 40,
                    position: "absolute",
                    top: "45%",
                    left: "48%",
                    fontSize: 50,
                    fontFamily: "IMPACT",
                    fontStyle: "normal",
                    opacity: showStream === false ? 1 : 0,
                    transition: "all 2s",
                  }
            }
          >
            {getEpcotShowTimeText()}
          </span>

          <span
            style={
              isTv
                ? {
                    zIndex: 40,
                    position: "absolute",
                    top: "55.0%",
                    left: "56%",
                    fontSize: 70,
                    fontFamily: "IMPACT",
                    color: "#0152CA",
                    fontStyle: "italic",
                    opacity: showStream === false ? 1 : 0,
                    transition: "all 2s",
                  }
                : {
                    zIndex: 40,
                    position: "absolute",
                    top: "54%",
                    left: "56%",
                    fontSize: 50,
                    fontFamily: "IMPACT",
                    color: "#0152CA",
                    fontStyle: "italic",
                    opacity: showStream === false ? 1 : 0,
                    transition: "all 2s",
                  }
            }
          >
            {moment
              .tz(config.terraceOpenTime, "HH:mm", "America/New_York")
              .format("LT")}{" "}
            (EST)
          </span>
        </>
      )}

      {/* <OffStreamBottomBar onBackClick={handleBackClick} /> */}
    </div>
  );
};

export default OffStreamView;
